import {
  ContractDetailSchema,
  ContractDownloadSchema,
  ContractListSchema,
  ContractResendResultSchema,
  ContractSigningLinkSchema,
} from '@utazzo/shared';

import type {
  ContractDetail,
  ContractDownload,
  ContractListItem,
  ContractResendResult,
  ContractSigningLink,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/** Contract e-signing endpoints (apps/api modules/contracts). */

export const fetchLeadContracts = async (leadId: string): Promise<ContractListItem[]> => {
  const { data } = await apiClient.get<unknown>('/contracts', { params: { leadId } });
  return ContractListSchema.parse(data);
};

export const fetchContract = async (id: string): Promise<ContractDetail> => {
  const { data } = await apiClient.get<unknown>(`/contracts/${id}`);
  return ContractDetailSchema.parse(data);
};

export const generateContractFromItinerary = async (
  itineraryId: string,
): Promise<ContractDetail> => {
  const { data } = await apiClient.post<unknown>('/contracts/from-itinerary', { itineraryId });
  // events is defaulted, so the create response (no events include) parses too.
  return ContractDetailSchema.parse(data);
};

export const resendContract = async (id: string): Promise<ContractResendResult> => {
  const { data } = await apiClient.post<unknown>(`/contracts/${id}/resend`);
  return ContractResendResultSchema.parse(data);
};

/** The customer's signing link, checked (and renewed if expired) on the server first. */
export const fetchSigningLink = async (id: string): Promise<ContractSigningLink> => {
  const { data } = await apiClient.post<unknown>(`/contracts/${id}/signing-link`);
  return ContractSigningLinkSchema.parse(data);
};

export const voidContract = async (id: string): Promise<void> => {
  await apiClient.post(`/contracts/${id}/void`);
};

export const fetchContractDownload = async (id: string): Promise<ContractDownload> => {
  const { data } = await apiClient.get<unknown>(`/contracts/${id}/download`);
  return ContractDownloadSchema.parse(data);
};
